// You can write more code here

/* START OF COMPILED CODE */

import PreloadScene from "../core/scenes/PreloadScene";
import PreloadImage from "../core/components/PreloadImage";
/* START-USER-IMPORTS */
import { assetsToLoad } from '../assets-to-load';
import { app } from '../core/App';
import { TransitionPoint } from '../app-routing';
/* END-USER-IMPORTS */

export default class PreloadTomAndJerry extends PreloadScene {

  constructor() {
    super("PreloadTomAndJerry");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {

    // bg
    const bg = this.add.image(960, 384, "preloader-tomandjerry", "1x1-blue.png");
    bg.scaleX = 1920;
    bg.scaleY = 768;
    bg.tintFill = true;
    bg.tintTopLeft = 35051;
    bg.tintTopRight = 35051;
    bg.tintBottomLeft = 35051;
    bg.tintBottomRight = 35051;

    // outline
    const outline = this.add.image(960, 591, "preloader-tomandjerry", "loading-bar-bg.png");

    // preloadBar
    const preloadBar = this.add.image(960, 591, "loading-bar-fill");

    // logo
    const logo = this.add.image(960, 307, "preloader-tomandjerry", "logo.png");

    // preloadBar (components)
    const preloadBarPreloadImage = new PreloadImage(preloadBar);
    preloadBarPreloadImage.reverseDirection = true;

    this.outline = outline;
    this.preloadBar = preloadBar;
    this.logo = logo;

    this.events.emit("scene-awake");
  }

  private outline!: Phaser.GameObjects.Image;
  private preloadBar!: Phaser.GameObjects.Image;
  private logo!: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  // Write your code here

  public preload() {
    this.editorCreate();

    this.add.tween({
      targets: this.logo,
      scaleX: 1.03,
      scaleY: 1.03,
      duration: 2000,
      ease: Phaser.Math.Easing.Quadratic.InOut,
      yoyo: true,
      repeat: -1
    });

    super.preload();

    assetsToLoad(this);

    this.load.on(Phaser.Loader.Events.COMPLETE, this.postload, this);
  }

  public postload() {
    super.postload();
  }

  public create() {
    super.create();
  }

  protected finish() {
    super.finish();

    app.afterPreload(() => {
      app.gotoNextScene(this, TransitionPoint.PreloadEnd, { test: 'test' });
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
